export default "__VITE_ASSET__B4v$g3hI__"